module.exports = __webpack_public_path__ + "static/media/hekeneshi.f61c82fb.svg";